import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { prop } from 'styled-tools';
import bgImg from './assets/background.png'
import bgFrame from './assets/background-frame.png'
import purpleContainer from './assets/purple-container.png'
import textBox from './assets/text-box.png'
import nextButton from './assets/next-button.png'
import skipButton from './assets/skip-button.png'
import card1 from './assets/dreamy-bubble.png'
import card2 from './assets/twinkle-skylar.png'
import card3 from './assets/harmony-ocean.png'
import card4 from './assets/jolly-trinity.png'
import backButton from './assets/back-button.png'
import { createUser, updateUserDisplayName } from './api/auth';
import { AuthProvider, initialAuthState } from './context/auth';
import { LoadingProvider } from './context/loading';
import { addUserStamp } from './api/stamp';
import { addViewHistory } from './api/history';

const Container = styled.div`
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  position: fixed;
  display: flex;
`;

const LoaderContainer = styled.div`
  display: flex;
  background: rgba(0, 0, 0, 0.6);
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;

const ContainerFrame = styled.div`
  height: 100%;
  width: 100%;
  max-width: 640px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url(${prop('background')}) no-repeat center;
  background-size: 95% 95%;
  position: fixed;
  display: flex;
`;

const PurpleContainer = styled.div`
  height: 50%;
  width: 85%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  margin-top: 1vh;
`;

const NextButton = styled.button`
  height: 6.5%;
  width: 40%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  margin-top: 2em;
  border: none;
`;

const SkipButton = styled.button`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: transparent;
  position: absolute;
  bottom: 4%;
  right: 10%;
  display: flex;
  margin-top: 2em;
  border: none;
`;

const CardButton = styled.button`
  height: 100%;
  width: 40%;
  background: url(${prop('background')}) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  border: none;
`;

const BackButton = styled.button`
  width: 15%;
  height: 5%;
  background: url(${prop('background')}) no-repeat center;
  background-size: contain;
  display: flex;
  border: none;
  position: absolute;
  top: 12%;
  left 5%;
`;

const authLocalStorageKeyPrefix = 'auth_harbour_city';

const getStoredAuth = () => {
  let storedAuth = null;
  if (localStorage.getItem(`${authLocalStorageKeyPrefix}`)) {
    try {
      storedAuth = JSON.parse(localStorage.getItem(`${authLocalStorageKeyPrefix}`));
    } catch (err) {
      storedAuth = null;
    }
  }
  return storedAuth;
};

const parseAuthData = (authData) => {
  const { id_token, ...remainData } = authData;
  try {
    const user = JSON.parse(atob(id_token.split('.')[1]));
    remainData.user = user;
  } catch (err) {
    console.error('err', err);
  }
  return remainData;
};

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      auth: getStoredAuth() || initialAuthState,
      loading: true,
      textContent: '',
      nextPage: false,
      textType: '2d',
      version: '1.0.66',
    }
    this.trackerRef = React.createRef();
  }

  setLoading = (isLoading) => {
    this.setState({ loading: isLoading });
  }
  
  setAuth = (newAuth) => {
    this.setState({ auth: newAuth });
    localStorage.setItem(`${authLocalStorageKeyPrefix}`, JSON.stringify(newAuth));
  }

  loadAuth = () => {
    const storedAuth = getStoredAuth();
    if (!(storedAuth && storedAuth.access_token)) {
      return createUser()
        .then(({ data }) => {
          const parsedAuth = parseAuthData(data);
          this.setAuth(parsedAuth);
          const username = parsedAuth.user.username;
          updateUserDisplayName(username, 'harbourcity', parsedAuth, this.setAuth);
          return parsedAuth;
        });
    }
    return Promise.resolve(storedAuth);
  }

  componentDidMount() {
    const { auth } = this.state;
    Promise.resolve(this.loadAuth())
      .then(addViewHistory(auth, this.setAuth))
      .catch(err => alert(err.message))
      .finally(() => this.setLoading(false));
  }

  textOnChange = (event) => {
    const inputText = document.getElementById('input');
    let string = event.target.value.replace(/'/g, "");
    if (string.length > 20) {
      alert('Exceed maximum 20 input characters.')
      string = string.slice(0, -1);
      inputText.value = string;
    }
    this.setState({ textContent: string });
  };

  // onClickCardButton = (cardNumber) => {
  //   const { version, textContent, textType } = this.state
  //   const zapparUrl = `https://whr.zappar.io/3543250898058833426/${version}/?text=${textContent}&textType=${textType}&cardNumber=${cardNumber}`;
  //   window.location.href = zapparUrl;
  // }

  onClickNextButton = () => {
    const textToCheck = this.state.textContent;
    const { version, textContent, textType, auth } = this.state
    let invalidText
    if (textToCheck) {
      const emojiRegex = /(\p{EPres}|\p{ExtPict})(\u200d(\p{EPres}|\p{ExtPict}))*/gu;
      invalidText = textToCheck.match(emojiRegex)
    }
    if (invalidText) {
      alert('Invalid text')
    } else if (textToCheck.length > 20) {
      alert('Exceed maximum 20 input characters.')
    } else {
      // this.setState({nextPage: true})
      const token = auth.access_token;
      const username = auth.user.username;
      const zapparUrl = `https://whr.zappar.io/3543250898058833426/${version}/?text=${textContent}&textType=${textType}&token=${token}&username=${username}`;
      window.location.href = zapparUrl;
      // addUserStamp('19bb5e6b-228b-4493-8cd9-e643a43c9d93', auth, this.setAuth).then(() => {  
      //   window.location.href = zapparUrl.toString();
      // })
    }
  }

  onChangeTextType = (event) => {
    this.setState({textType: event.target.value})
  }

  render() {
    const { auth, loading, nextPage } = this.state
    return (
      <AuthProvider value={{ auth, setAuth: this.setAuth }}>
        <LoadingProvider value={{ loading, setLoading: this.setLoading }}>
          <Container background={bgImg}>
            <ContainerFrame background={bgFrame}>
              <div style={{ marginTop: '1rem', color: '#5F4580', fontFamily: 'Comfortaa-Bold', fontWeight: 'bolder', fontSize: '3vh' }}>
                送出你的祝福句
              </div>
              <div style={{ color: '#5F4580', fontFamily: 'Amelaryas', fontSize: '2vh', marginTop: '-1.5vh'}}>
                Send your blessing
              </div>
              <PurpleContainer background={purpleContainer}>
                <div style={{ paddingLeft: '3vh', paddingRight: '3vh', display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{ display: 'flex', marginBottom: '1vh', justifyContent: 'center', fontSize: '2.5vh', color: 'white', fontFamily: 'Comfortaa' }}>
                    在此輸入 Type Here:
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <input id="input" type="text" value={this.textContent} onChange={this.textOnChange} style={{ paddingLeft: 10, paddingRight: 10, position: 'absolute', border: 'none', overflow: 'hidden', fontSize: '1em', background: 'transparent', display: 'flex', width: '78%' }} />
                    <img src={textBox} width="100%" alt="" />
                  </div>
                  <div style={{ fontFamily: 'Comfortaa', marginTop: '3vh', display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-around', alignItems: 'center', fontSize: '0.9rem', color: 'white' }}>
                    <div>
                      <input type="radio" value="2d" name="text" onChange={this.onChangeTextType} checked={this.state.textType === '2d'} /> 2-D 字型 Font
                    </div>
                    <div>
                      <input type="radio" value="3d" name="text" onChange={this.onChangeTextType} checked={this.state.textType === '3d'} /> 3-D 字型 Font
                    </div>
                  </div>
                </div>
              </PurpleContainer>
              <NextButton background={nextButton} onClick={this.onClickNextButton} />
              <SkipButton onClick={this.onClickNextButton}>
                <div style={{ marginTop: '1rem', color: '#5F4580', fontFamily: 'Comfortaa-Bold', fontWeight: 'bolder', fontSize: '1.8em' }}>
                  略過 Skip
                </div>
              </SkipButton>
              {/* {nextPage && <>
                <BackButton background={backButton} onClick={()=> this.setState({nextPage: false})} />
                <div style={{ marginTop: '2rem', color: '#5F4580', fontFamily: 'Comfortaa-Bold', fontWeight: 'bolder', fontSize: '3vh' }}>
                  請選擇其中一張卡
                </div>
                <div style={{ color: '#5F4580', fontFamily: 'Amelaryas', fontSize: '2vh', marginTop: '-1.5vh'}}>
                  Please Choose A Card
                </div>
                <PurpleContainer background={purpleContainer} style={{ height: '65%' }}>
                  <div style={{ display: 'flex', width: '95%', flex: 1, flexDirection: 'row', padding: '3vh', justifyContent: 'space-evenly' }}>
                    <CardButton background={card1} onClick={()=> this.onClickCardButton(1)}/>
                    <CardButton background={card2} onClick={()=> this.onClickCardButton(2)}/>
                  </div>
                  <div style={{ display: 'flex', width: '95%', flex: 1, flexDirection: 'row', padding: '3vh', paddingTop: 0, justifyContent: 'space-evenly' }}>
                    <CardButton background={card3} onClick={()=> this.onClickCardButton(3)}/>
                    <CardButton background={card4} onClick={() => this.onClickCardButton(4)}/>
                  </div>
                </PurpleContainer>
              </>} */}
            </ContainerFrame>
            {loading && (
              <LoaderContainer>
                <div style={{ color: 'white', fontFamily: 'Comfortaa-Bold', fontWeight: 'bolder', fontSize: '5vh', textAlign: 'center' }}>Loading...</div>
              </LoaderContainer>
            )}
          </Container>
        </LoadingProvider>
      </AuthProvider>
    )
  }
}

export default withRouter(App);
